import Vue from 'vue'

export default function roomCallStreamEventListener(room) {
    return store => {
        room.addEventListeners({
            noise_cancel_failed: e => {
                console.error('noise cancel failed :', e);
                store.commit('room/NOISE_CANCEL_DISABLE');
            }
        });
    }
}
